import Select from 'react-select'
import { useMemo, useState } from 'react'
import { usePlainList } from '@inmagik/react-crud'

export default function SelectAutoCompleteFilter({
  value,
  onChange,
  url = '/api/progetti/options/',
  keyQuery = 'id',
  isMulti = true,
  params = {},
  isDisabled = false,
  placeholder,
  className,
  menuPortalTarget = true,
}: {
  value: any
  onChange: any
  url?: string
  isMulti?: boolean
  keyQuery?: string
  params?: any
  isDisabled?: boolean
  placeholder?: string
  className?: string
  menuPortalTarget?: boolean
}) {
  const [search, setSearch] = useState<string>('')
  const [focus, setFocus] = useState<boolean>(false)

  const valueToSend = useMemo(() => {
    if (!isMulti) {
      return value
    }
    if (!value || value.length === 0) {
      return []
    }
    const finalValue = value.join(',')
    return finalValue
  }, [value, isMulti])

  const { data: items, isFetching: isFetchingPrimary } = usePlainList(
    url,
    { ...params, search },
    {
      enabled: !!search || focus,
    }
  )

  const paramsToSend = useMemo(() => {
    if (!isMulti) {
      return {
        id: valueToSend ?? '',
      }
    } else {
      return {
        ids: valueToSend,
      }
    }
  }, [valueToSend, isMulti])

  const { data: values, isFetching } = usePlainList(
    url,
    { ...(paramsToSend as any) },
    {
      enabled: !!valueToSend || focus,
    }
  )

  const valueForSelect = useMemo(() => {
    if (!value || value.length === 0 || isFetching) {
      return []
    }
    return values?.map((v: any) => ({
      value: String(v.value),
      label: v.label,
    }))
  }, [values, value, isFetching])

  return (
    <Select
      isMulti={isMulti}
      isClearable
      className={className ? className : ''}
      isSearchable
      options={(items as any) ?? []}
      onMenuOpen={() => {
        setFocus(true)
      }}
      // set is-invalid class if there is an error
      isDisabled={isDisabled}
      value={valueForSelect}
      openMenuOnClick={true}
      // avoid z-index issues
      menuPortalTarget={menuPortalTarget ? document.body : null}
      hideSelectedOptions={true}
      placeholder={placeholder ?? 'Seleziona'}
      noOptionsMessage={() => 'Nessuna opzione'}
      onChange={onChange}
      isLoading={isFetchingPrimary}
      onInputChange={(value) => {
        setSearch(value)
      }}
    />
  )
}
